import { render, staticRenderFns } from "./RateStar.vue?vue&type=template&id=837c1a4a&scoped=true"
import script from "./RateStar.vue?vue&type=script&lang=js"
export * from "./RateStar.vue?vue&type=script&lang=js"
import style0 from "./RateStar.vue?vue&type=style&index=0&id=837c1a4a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837c1a4a",
  null
  
)

export default component.exports